import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { ConfigService } from '../config-service';
import { ConfigKey } from '../constants/config-key.constants';

/**
 * configIf checks if the value of the key passed in is 'true'/'false'. If the value is false, the DOM element is hidden.
 * Example usage:
 *    <div *configIf="'A_KEY_WHICH_RETURNS_TRUE'">Something</div>
 *    <div *configIf="'A_KEY_WHICH_RETURNS_TRUE'; default: true">Something</div>
 * The above will be displayed.
 */
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[configIf]'
})
export class ConfigIfDirective {
	private _configIf: ConfigKey = null;
	private _configDefaultValue: boolean = false;
	private isContentShown: boolean = false; // to avoid double elements showing

	constructor(private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef, private configService: ConfigService) { }

	@Input() public set configIf(conditionKey: string) {
		this._configIf = conditionKey as ConfigKey;
		this.toggleDomVisibility();
	}

	@Input() public set configIfDefault(defaultValue: boolean) {
		this._configDefaultValue = defaultValue;
		this.toggleDomVisibility();
	}

	private toggleDomVisibility(): void {
		const shouldShow = this.configService.get<boolean>(this._configIf, this._configDefaultValue);

		if (shouldShow) {
			if (!this.isContentShown) {
				this.viewContainerRef.createEmbeddedView(this.templateRef);
				this.isContentShown = true;
			}
		} else {
			this.isContentShown = false;
			this.viewContainerRef.clear();
		}
	}
}
